import { Outlet } from "react-router-dom";

const TechnologyLayout = () => {
  return <Outlet />;
};
export default TechnologyLayout;
